import { resetUser } from "@onsand/analytics";
import { clearClientToken } from "@onsand/api";
import { auth } from "@onsand/auth";
import { signOut } from "firebase/auth";

let signingOut = false;

/**
 * Ends the session and lands on the login page. Runs once: a dead session fails every request
 * in flight at the same moment, and each of them asks for this.
 */
export async function signOutAndGoToLogin(): Promise<void> {
	if (signingOut) return;
	signingOut = true;
	resetUser();
	// The cookie goes first: while it lingers, the middleware bounces /login straight back in.
	clearClientToken();
	await signOut(auth).catch(() => undefined);
	window.location.href = "/login";
}
